(function () {
  'use strict';
  function all(selector, parent) { return Array.from((parent || document).querySelectorAll(selector)); }
  function closeMenus(except) {
    all('.enterprise-header details[open]').forEach(function (menu) {
      if (menu !== except && !(except && menu.contains(except))) menu.open = false;
    });
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.enterprise-header')) closeMenus();
    var summary = event.target.closest('.enterprise-header summary');
    if (summary) closeMenus(summary.parentElement);
    if (event.target.closest('[data-reload-page]')) {
      var section = event.target.closest('[data-product-section]');
      var url = new URL(window.location.href);
      var select = section && section.querySelector('[data-variant-select]');
      var quantity = section && section.querySelector('[data-order-quantity]');
      if (select) url.searchParams.set('variant', select.value);
      if (quantity && quantity.validity.valid) url.searchParams.set('quantity', quantity.value);
      window.history.replaceState({}, '', url);
      window.location.reload();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var menu = event.target.closest('.enterprise-header details[open]');
    var parentMenu;
    while (menu && (parentMenu = menu.parentElement.closest('.enterprise-header details[open]'))) {
      menu = parentMenu;
    }
    closeMenus();
    if (menu) menu.querySelector('summary').focus();
  });
  function showMedia(section, id) {
    if (!id || !all('[data-media-id]', section).some(function (node) { return node.dataset.mediaId === id; })) return;
    all('[data-media-id]', section).forEach(function (node) {
      node.hidden = node.dataset.mediaId !== id;
      if (node.hidden) all('video', node).forEach(function (video) { video.pause(); });
    });
    all('[data-show-media]', section).forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.showMedia === id)); });
    var activePhoto = all('[data-media-id]', section).find(function (node) { return node.dataset.mediaId === id; });
    var photoCaption = section.querySelector('[data-gallery-caption]');
    if (photoCaption) {
      if (!photoCaption.dataset.defaultCaption) photoCaption.dataset.defaultCaption = photoCaption.textContent;
      photoCaption.textContent = activePhoto?.dataset.photoCaption || photoCaption.dataset.defaultCaption;
    }

  }
  function syncProduct(section, updateUrl) {
    var select = section.querySelector('[data-variant-select]');
    var choice = select ? select.selectedOptions[0] : section.querySelector('input[name="id"]');
    if (!choice) return;
    var available = choice.dataset.available === 'true';
    var button = section.querySelector('[data-add-to-cart]');
    if (button) { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; }
    var status = section.querySelector('[data-variant-status]');
    if (status) status.textContent = available ? '' : 'This option is currently sold out. Choose another option or contact us.';
    var artwork = section.querySelector('[data-artwork-panel]');
    if (artwork) artwork.hidden = !available;
    if (select) {
      section.querySelector('[data-product-price]').textContent = choice.dataset.price;
      var compare = section.querySelector('[data-product-compare]');
      compare.hidden = !choice.dataset.comparePrice;
      compare.textContent = choice.dataset.comparePrice || '';
      showMedia(section, choice.dataset.media);
      var quantity = section.querySelector('input[name="quantity"]');
      if (quantity) {
        quantity.min = choice.dataset.min || '1'; quantity.step = choice.dataset.step || '1';
        if (choice.dataset.max) quantity.max = choice.dataset.max; else quantity.removeAttribute('max');
        var min = Number(quantity.min), step = Number(quantity.step), value = Number(quantity.value);
        if (!Number.isFinite(value) || value < min) value = min;
        value = min + Math.ceil((value - min) / step) * step;
        if (quantity.max) value = Math.min(value, Number(quantity.max));
        quantity.value = String(value);
      }
      if (updateUrl && !(window.Shopify && window.Shopify.designMode)) {
        var url = new URL(window.location.href); url.searchParams.set('variant', choice.value);
        window.history.replaceState({}, '', url);
      }
    }
  }
  function initProduct(section) {
    if (section.bbdtfCleanup) section.bbdtfCleanup();
    var select = section.querySelector('[data-variant-select]');
    var params = new URL(window.location.href).searchParams;
    if (select && params.get('variant')) {
      var initialOption = Array.from(select.options).find(function (o) { return o.value === params.get('variant'); });
      if (initialOption) initialOption.selected = true;
    }
    var initialQuantity = section.querySelector('input[name="quantity"]');
    if (initialQuantity && /^[1-9][0-9]*$/.test(params.get('quantity') || '')) initialQuantity.value = params.get('quantity');
    var change = function () { syncProduct(section, true); };
    if (select) select.addEventListener('change', change);
    var click = function (event) { var button = event.target.closest('[data-show-media]'); if (button) showMedia(section, button.dataset.showMedia); };
    section.addEventListener('click', click);
    var form = section.querySelector('.product-form');
    var submit = function (event) {
      // App blocks are outside this native form; their own submission is unaffected.
      if (section.dataset.artworkRequired === 'true') {
        event.preventDefault();
        var panel = section.querySelector('[data-artwork-panel]');
        if (panel && !panel.hidden) {
          panel.setAttribute('tabindex', '-1');
          panel.scrollIntoView({ block: 'nearest' });
          panel.focus({ preventScroll: true });
        }
      } else {
        var choice = select ? select.selectedOptions[0] : section.querySelector('input[name="id"]');
        if (!choice || choice.dataset.available !== 'true') event.preventDefault();
      }
    };
    if (form) form.addEventListener('submit', submit);
    syncProduct(section, false);
    var panel = section.querySelector('[data-artwork-panel]'), observer, timeout;
    if (panel) {
      var message = panel.querySelector('[data-artwork-status]');
      var fallback = panel.querySelector('[data-artwork-fallback]');
      var ready = false;
      var revealFallback = function () { if (!ready && fallback) { fallback.hidden = false; message.hidden = true; } };
      var check = function () {
        var controls = all('.product-app-block #submit-link, .product-app-block #upload-link, .product-app-block input[type="file"], .product-app-block [data-artwork-launch]', panel);
        var found = controls.some(function (node) { return !node.disabled && node.getClientRects().length > 0 && window.getComputedStyle(node).visibility !== 'hidden'; });
        ready = found;
        panel.dataset.toolReady = String(found);
        if (found) {
          message.textContent = panel.dataset.readyMessage; message.hidden = false;
          if (fallback) fallback.hidden = true;
          if (timeout) window.clearTimeout(timeout);
          timeout = null;
        } else if (!timeout) {
          message.textContent = panel.dataset.loadingMessage;
          timeout = window.setTimeout(revealFallback, 8000);
        }
      };
      observer = new MutationObserver(check);
      observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      all('.product-app-block', panel).forEach(function (node) { observer.observe(node, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'disabled', 'hidden'] }); });
      if (!panel.querySelector('.product-app-block')) revealFallback();
      else check();
    }
    section.bbdtfCleanup = function () {
      if (select) select.removeEventListener('change', change);
      section.removeEventListener('click', click);
      if (form) form.removeEventListener('submit', submit);
      if (observer) observer.disconnect();
      if (timeout) window.clearTimeout(timeout);
    };
  }
  // This clock describes a cutoff, never available capacity or a delivery promise.
  function updateCutoff() {
    var config = document.querySelector('[data-cutoff-config]');
    if (!config) return;
    var closures = (config.dataset.closedDates || '').split(/[\s,]+/);
    var parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).map(function (part) { return [part.type, part.value]; }));
    var date = parts.year + '-' + parts.month + '-' + parts.day;
    var before = !['Sat', 'Sun'].includes(parts.weekday) && !closures.includes(date) && Number(parts.hour) < 12;
    var remaining = 720 - Number(parts.hour) * 60 - Number(parts.minute);
    all('[data-cutoff-badge]').forEach(function (node) { node.textContent = before ? 'Ordering cutoff: 12 PM ET' : 'Next production window'; });
    all('[data-cutoff-detail]').forEach(function (node) { node.textContent = before ? Math.floor(remaining / 60) + 'h ' + remaining % 60 + 'm until today’s ordering cutoff.' : 'Contact us if your order has a specific deadline.'; });
    all('[data-cutoff-status]').forEach(function (node) { node.textContent = 'Timing is confirmed after artwork and payment review.'; });
    all('[data-cutoff-note]').forEach(function (node) { node.textContent = 'The cutoff alone does not confirm available capacity or a completion time.'; });
  }
  function init(root) {
    all('[data-product-section]', root).forEach(initProduct);
    if (root.matches && root.matches('[data-product-section]')) initProduct(root);
    all('.enterprise-header a[href], .enterprise-footer a[href]', root).forEach(function (link) {
      if (new URL(link.href).pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')) link.setAttribute('aria-current', 'page');
    });
    updateCutoff();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { all('[data-product-section]', event.target).forEach(function (node) { if (node.bbdtfCleanup) node.bbdtfCleanup(); }); });
  window.addEventListener('popstate', function () { all('[data-product-section]').forEach(function (section) { var select = section.querySelector('[data-variant-select]'); var variant = new URL(window.location.href).searchParams.get('variant'); if (select && variant && Array.from(select.options).some(function (o) { return o.value === variant; })) { select.value = variant; select.dispatchEvent(new Event('change', { bubbles: true })); } }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) updateCutoff(); });
  window.setInterval(function () { if (!document.hidden) updateCutoff(); }, 15000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
})();
